export default "<style>\r\n  \r\n  [data-click-info]\r\n  {\r\n    cursor: pointer;\r\n  }\r\n\r\n</style>";